import { Modal } from "react-bootstrap";
import { UpdateAttachmentModalProps } from "./Task.types";
import { GenericForm } from "../../components/generic-form";
import { Button } from "../../components/button";
import { useTranslation } from "react-i18next";

export const UpdateAttachmentModal = ({
  show,
  onDismiss,
  onSubmit,
  updateAttachmentForm,
  editing,
}: UpdateAttachmentModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          {t("TASKS.EDIT_ATTACHMENT")}
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body className="flex-column gap-2">
        <GenericForm
          form={updateAttachmentForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={editing}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                {t("SAVE_BUTTON")}
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};
